<div class="verification-box" *ngIf="pendingVerifications.length">
  <mat-card>
    <div class="verification-box__header">
      <div>
        <h3>Historia weryfikacji zmian wizytówki DA</h3>
        <p>
          Lista zmian zgłoszonych przez Agentów w wizytówce DobryAgent.pl wraz ze statusem weryfikacji.
        </p>
      </div>
    </div>

    <table
      mat-table
      [dataSource]="pendingVerifications"
      multiTemplateDataRows
      class="verification-table mat-elevation-z1"
    >
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Data zgłoszenia</th>
        <td mat-cell *matCellDef="let verification">
          {{ verification.createdAt | date: 'dd.MM.yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef>Użytkownik</th>
        <td mat-cell *matCellDef="let verification">
          <div class="user-cell">
            <strong>{{ verification.submittedByFullName || '—' }}</strong><br>
            <span>{{ verification.submittedByEmail || '—' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let verification">
          <button mat-raised-button style="width: 100%"
                  [ngClass]="verification.verificationStatus?.color + '-button'">{{ verification.verificationStatus?.name }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="reviewedBy">
        <th mat-header-cell *matHeaderCellDef>Zweryfikowane przez</th>
        <td mat-cell *matCellDef="let verification">
          <div class="user-cell">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', verification.reviewedByUserUuid]"> <strong>{{ verification.reviewedByFullName || '—' }}</strong></a><br>
<!--            <span>{{ verification.reviewedByEmail || '—' }}</span>-->
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="changes">
        <th mat-header-cell *matHeaderCellDef>Zakres zmian</th>
        <td mat-cell *matCellDef="let verification">
          <div class="changes-list">
            <mat-chip *ngFor="let field of getChangedFields(verification)">
              <span class="text-sm">{{ getFieldLabel(field) }}</span>
            </mat-chip>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="more">
        <th mat-header-cell *matHeaderCellDef class="more-column">Akcje</th>
        <td mat-cell *matCellDef="let verification" class="more-column">

          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="processingVerificationUuid === verification.uuid"
            (click)="toggleDetails(verification)"
          >
            Szczegóły
          </button>


        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let verification"
          [attr.colspan]="displayedColumns.length"
        >
          <div
            class="details"
            fxLayout="column"
            fxLayoutGap="15px"
            *ngIf="expandedVerification?.uuid === verification.uuid "
          >
            <ng-container *ngIf="verification?.rejectionReason">
              <app-detail fxFlex="100" header="Powód odrzucenia" [value]="verification?.rejectionReason"></app-detail>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="space-between center" >
              <h4>Porównanie zmian</h4>
              <div
                class="details-actions"
                *ngIf="verification.verificationStatus?.key === 'pending'"
              >
                <button
                  mat-stroked-button
                  color="warn"
                  type="button"
                  [disabled]="isProcessing(verification)"
                  (click)="reject(verification)"
                >
                  Odrzuć
                </button>

                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  [disabled]="isProcessing(verification)"
                  (click)="edit(verification)"
                >
                  Edytuj
                </button>

                <button
                  mat-flat-button
                  color="accent"
                  type="button"
                  [disabled]="isProcessing(verification)"
                  (click)="accept(verification)"
                >
                  Akceptuj
                </button>
              </div>
            </div>
            <table fxFlex="100" class="comparison-table">
              <colgroup>
                <col class="comparison-table__field-column"/>
                <col class="comparison-table__value-column"/>
                <col class="comparison-table__value-column"/>
              </colgroup>

              <thead>
              <tr>
                <th>Pole</th>
                <th>Aktualna wartość</th>
                <th>Zgłoszona wartość</th>
              </tr>
              </thead>

              <tbody>
              <tr *ngFor="let field of getChangedFields(verification)">
                <td>
                  <strong>{{ getFieldLabel(field) }}</strong>
                </td>

                <td>
                  <ng-container *ngIf="field === 'images'; else previousTextValue">
                    <div class="verification-images">
                      <ng-container *ngFor="let image of asImages(getPreviousValue(verification, field))">
                        <div class="verification-image">
                          <img
                            *ngIf="image.location"
                            [src]="getImageUrl(image.location)"
                            [alt]="'Aktualne zdjęcie'"
                          />

                          <span *ngIf="image.isDeleted"
                                class="verification-image__badge verification-image__badge--deleted">
                          Usunięte
                        </span>
                        </div>
                      </ng-container>

                      <span *ngIf="asImages(getPreviousValue(verification, field)).length === 0">—</span>
                    </div>
                  </ng-container>

                  <ng-template #previousTextValue>
                    <ng-container *ngIf="field === 'openHours'; else previousDefaultValue">
                      <div class="opening-hours-preview">
                        <div
                          class="opening-hours-preview__row"
                          *ngFor="let item of formatOpeningHours(getPreviousValue(verification, field))"
                        >
                          <span class="opening-hours-preview__day">{{ item.label }}</span>
                          <span
                            class="opening-hours-preview__time"
                            [class.opening-hours-preview__time--closed]="item.closed"
                          >   {{ item.closed ? 'Nieczynne' : item.openTime + ' - ' + item.closeTime }} </span>
                        </div>

                        <span *ngIf="formatOpeningHours(getPreviousValue(verification, field)).length === 0">—</span>
                      </div>
                    </ng-container>

                    <ng-template #previousDefaultValue>
                      <span [innerHTML]="formatValue(getPreviousValue(verification, field))"> </span>
                    </ng-template>
                  </ng-template>
                </td>

                <td>
                  <ng-container *ngIf="field === 'images'; else changedTextValue">
                    <div class="verification-images">
                      <ng-container *ngFor="let image of asImages(getChangedValue(verification, field))">
                        <div class="verification-image">
                          <img
                            *ngIf="image.location"
                            [src]="getImageUrl(image.location)"
                            [alt]="'Zgłoszone zdjęcie'"
                          />

                          <span *ngIf="image.isNew" class="verification-image__badge verification-image__badge--new">
                              Nowe
                            </span>
                          <span *ngIf="image.isDeleted"
                                class="verification-image__badge verification-image__badge--deleted">
                            Do usunięcia
                          </span>
                        </div>
                      </ng-container>

                      <span *ngIf="asImages(getChangedValue(verification, field)).length === 0">—</span>
                    </div>
                  </ng-container>

                  <ng-template #changedTextValue>
                    <ng-container *ngIf="field === 'openHours'; else changedDefaultValue">
                      <div class="opening-hours-preview">
                        <div
                          class="opening-hours-preview__row"
                          *ngFor="let item of formatOpeningHours(getChangedValue(verification, field))"
                        >
                          <span class="opening-hours-preview__day">{{ item.label }}</span>
                          <span
                            class="opening-hours-preview__time"
                            [class.opening-hours-preview__time--closed]="item.closed"
                          >  {{ item.closed ? 'Nieczynne' : item.openTime + ' - ' + item.closeTime }}  </span>
                        </div>

                        <span *ngIf="formatOpeningHours(getChangedValue(verification, field)).length === 0">—</span>
                      </div>
                    </ng-container>

                    <ng-template #changedDefaultValue>
                      <span [innerHTML]="formatValue(getChangedValue(verification, field)) "></span>
                    </ng-template>
                  </ng-template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="verification-row"
        [class.verification-row--expanded]="expandedVerification?.uuid === row.uuid"
      ></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
        [class.detail-row--expanded]="expandedVerification?.uuid === row.uuid"
      ></tr>
    </table>
  </mat-card>

</div>
